
/**
* @description Given a URL and a path, combine the two together using the foolproof native URL class.
*/
export function buildUrl(url: string, path: string): string {
    if (url)
    {
        // Use as base url composition
        return new URL(path, url).toString();
    }
    else
    {
        // Asssume no base url, just return relative path.
        return path;
    }
}